// @flow
import React, { Component } from 'react';
import { HeaderDiv } from './CryptoWalletsStyles';
import Description from './Description';
import {
  SaveButtonDiv,
  SaveButton,
  SavePromptP,
  SaveSuccessP,
  ErrorP
} from '../../../components/SaveOverlayStyles';

type Props = {
  pristine: boolean,
  submitting: boolean,
  submitSucceeded: boolean,
  error: ?string
};

export default class Header extends Component<Props> {
  render() {
    return (
      <HeaderDiv>
        <Description />
        <SaveButtonDiv column>
          <SaveButton
            type="submit"
            value="Save"
            disabled={this.props.pristine || this.props.submitting}
          />
          {Boolean(this.props.error) || this.props.pristine || (
            <SavePromptP>You have unsaved changes</SavePromptP>
          )}
          {this.props.error && <ErrorP>{this.props.error}</ErrorP>}
          {this.props.submitSucceeded && this.props.pristine && (
            <SaveSuccessP>Saved!</SaveSuccessP>
          )}
        </SaveButtonDiv>
      </HeaderDiv>
    );
  }
}
